import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import style from './toolbarDownloadModal.module.scss';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
import CloseIcon from '@/images/icons/modal-close-btn.svg';
import { getIn18Text, apiHolder, conf, inWindow, api, apis } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import { TongyongJiantou1You } from '@sirius/icons';
const { isMac } = apiHolder.env;
const isWebmail = inWindow() && conf('profile') ? conf('profile').toString().includes('webmail') : false;
const ToolbarDownloadModal = ({ visible: defulatVisible, onClose: closeModal }) => {
    var _a, _b;
    const isWindows = !isMac;
    const [visible, setVisible] = useState(false);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
    const systemApi = api.getSystemApi();
    const isEnLang = inWindow() && window.systemLang === 'en';
    const sid = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.sessionId;
    const uid = (_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id;
    const newHost = mailConfApi.getNewWebMailHost();
    const hl = isEnLang ? 'en_US' : 'zh_CN';
    const webMailSettingConfig = {
        setting: {
            url: `${newHost}/static/commonweb/authcode.html?hl=${hl}&ver=js6&fontface=none&style=7&lang=ch&skin=skyblue&color=003399&sid=${sid}&uid=${uid}&host=${newHost}`,
            params: { subModName: 'authCode', link: 'option_authCode' },
        },
    };
    const handleToMailSettingInLocal = async (name, urlType, openInElectron, haveJquery) => {
        const url = systemApi.isElectron()
            ? mailConfApi.getSettingUrl(name, urlType)
            : isCorpMail
                ? mailConfApi.getCorpSettingUrl(name, urlType.params)
                : await mailConfApi.getWebSettingUrlInLocal(name, urlType);
        if (url && url.length > 0) {
            systemApi.openNewWindow(url, openInElectron, undefined, undefined, haveJquery);
        }
        else {
            Toast.warn({
                content: getIn18Text('WUFADAKAIZHI'),
                duration: 3,
            });
        }
    };
    useEffect(() => {
        setVisible(defulatVisible);
    }, [defulatVisible]);
    return (React.createElement(Modal, { visible: visible, className: style.downloadModalWrap, width: 1400, footer: null, afterClose: closeModal, centered: true, onCancel: () => {
            closeModal();
        }, closeIcon: React.createElement("img", { style: {
                width: '16px',
                height: '16px',
            }, src: CloseIcon }) },
        React.createElement("span", { className: style.title }, getIn18Text('toobar_download_modal_title')),
        React.createElement("span", { className: style.desc }, getIn18Text('toobar_download_modal_desc')),
        React.createElement("iframe", { className: classnames(style.appCont, isWindows ? style.appContWin : ''), src: `https://mailh.qiye.163.com/static/commonweb/dashiDownload.html?from=${isWebmail ? 'lingxiNewWeb' : 'lingxiWeb'}` }),
        React.createElement("div", { className: style.thirdPartySection },
            React.createElement("div", { className: style.thirdPartyTitle },
                React.createElement("span", { className: style.thirdPartyTitleLine }),
                React.createElement("span", { className: style.thirdPartyTitleText }, "\u4F7F\u7528\u7B2C\u4E09\u65B9\u90AE\u4EF6\u5BA2\u6237\u7AEF"),
                React.createElement("span", { className: style.thirdPartyTitleLine })),
            React.createElement("div", { className: style.thirdPartyDesc },
                React.createElement("span", { className: style.thirdPartyDescText }, "\u652F\u6301 Outlook\u3001Foxmail\u3001\u4F01\u4E1A\u5FAE\u4FE1\u7B49\u90AE\u4EF6\u5BA2\u6237\u7AEF\u767B\u5F55\uFF0C\u4F7F\u7528\u524D\u9700\u5F00\u542F IMAP/SMTP\u534F\u8BAE\u5E76\u751F\u6210\u5BA2\u6237\u7AEF\u6388\u6743\u5BC6\u7801\u3002"),
                React.createElement("span", { className: style.thirdPartyLink, onClick: () => {
                        handleToMailSettingInLocal('options.LinkModule', webMailSettingConfig.setting, true, true);
                    } },
                    "\u751F\u6210\u5BA2\u6237\u7AEF\u6388\u6743\u5BC6\u7801",
                    React.createElement(TongyongJiantou1You, { className: style.thirdPartyArrow, wrapClassName: style.thirdPartyArrowWrap }))))));
};
export default ToolbarDownloadModal;
